import type { Language } from "@app/constants";

interface Messages {
	altLogo: string;
	disclaimer1: string;
	disclaimer2: string;
	getInTouch: {
		addressLine1: string;
		addressLine2: string;
		emailAddress: string;
		heading: string;
		phoneNumber: string;
	};
	legal: {
		heading: string;
		privacyPolicy: string;
		termsAndConditions: string;
		termsOfUse: string;
	};
	sloganLine1: string;
	sloganLine2: string;
	quickLinks: {
		about: string;
		careers: string;
		faqs: string;
		heading: string;
	};
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		altLogo: "Future Forex Logo",
		disclaimer1:
			"Future Forex SA (Pty) Ltd is an authorised Financial Services Provider (FSP 51884) - it is licensed for the remittance of international payments only. Future Forex SA is a regulated primary accountable institution with the Financial Intelligence Centre (FIC).",
		disclaimer2:
			"For the circumstances of “unregulated cryptocurrencies”, we provide a forex intermediary service, with zero financial advice, within the framework of the FSCA, SARB and Currency and Exchanges Act.",
		getInTouch: {
			addressLine1: "66 Roeland Street,",
			addressLine2: "Cape Town, South Africa",
			emailAddress: "info@futureforex.co.za  ",
			heading: "GET IN TOUCH",
			phoneNumber: "+27 (0)21 518 0558 ",
		},
		legal: {
			heading: "LEGAL",
			privacyPolicy: "Privacy Policy",
			termsAndConditions: "Terms and Conditions",
			termsOfUse: "Website Terms of Use",
		},
		sloganLine1: "Your partner in low-risk,",
		sloganLine2: "high yield Crypto Asset Arbitrage.",
		quickLinks: {
			about: "About",
			careers: "Careers",
			faqs: "FAQs",
			heading: "QUICK LINKS",
		},
	},
};

export default messages;
